import React, { useContext } from "react";
import Translator from "bazinga-translator" ;
import { LocaleContext } from "../Context/Locale";
import { RenderContext } from "../Context/Ssr";

export const CatalogContext = React.createContext(null);

const withTranslator = ComposedComponent => (props) =>  {
    const render = useContext(RenderContext);
    const locale = useContext(LocaleContext);

    const getTranslator = () => {
        if (typeof window !== 'undefined') {
            const translations = document.getElementById('translations')
            if (!window.CVTranslator || translations.getAttribute('locale') != locale) {
                translations.setAttribute('locale', locale);
                if (window.CVTranslator) {
                    window.CVTranslator.reset();
                    window.CVTranslator.fromJSON(translations.innerHTML);
                } else {
                    window.CVTranslator = Translator;
                    window.CVTranslator.fromJSON(translations.innerHTML);
                }
            }
            return window.CVTranslator;
        } else {
            if (render.serverSide) {
                Translator.fromJSON(TRANSLATIONS[locale]);
                return Translator;
            }
        }
    }
    let localTranslator = getTranslator();

    const t = catalog => (key, data) =>  localTranslator.trans(key, data, catalog, locale) ;

    return (
            <CatalogContext.Consumer>
                {catalog => <ComposedComponent {...props} t={t(catalog)} />}
            </CatalogContext.Consumer>
    );

};

export default withTranslator;
